const isWeb = true;
const isMRN = false;
export function appendParams(url, params) {
    // 分离 hash 部分
    const [baseUrlWithQuery, hash] = url.split('#');
    const [baseUrl, queryString] = baseUrlWithQuery.split('?');
    // 解析现有查询参数
    const queryParams = queryString ? queryString.split('&') : [];
    const existingParams = {};
    queryParams.forEach(pair => {
        const [key, value] = pair.split('=');
        existingParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    // 合并新参数
    const combinedParams = {
        ...existingParams,
        ...params
    };
    // 构建新的查询字符串
    const newQueryString = Object.entries(combinedParams).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    // 拼接最终的 URL
    return `${baseUrl}?${newQueryString}${hash ? `#${hash}` : ''}`;
}
export const getQueryParams = (ctx) => {
    const params = {};
    if (isWeb) {
        const queryString = window.location.search.substring(1);
        const queryArray = queryString.split('&');
        queryArray.forEach(query => {
            const [key, value] = query.split('=');
            params[key] = decodeURIComponent(value);
        });
        //  params['cityId'] = params['cityId'] || ctx._runtimeInfo.queryParams?.cityId;
    }
    // console.log('params:========= ',isWeb, params);
    return params;
};
export const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
